export default {
  SET_TOTAL_UNREAD_COUNT(state, count) {
    state.unreadMessages = count
  }
}
